import type { IconProps } from './icon.types'

const AlertIcon = (props: IconProps) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 18 18'
    fill='none'
    stroke='currentColor'
    strokeWidth='1.2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    data-testid='alert-icon'
    {...props}
  >
    <circle cx='9' cy='9' r='7' />
    <path d='M9 5.5v4' />
    <circle cx='9' cy='12.4' r='.6' fill='currentColor' stroke='none' />
  </svg>
)

export default AlertIcon
